// -----------------------------------------------------------------------------
// InventoryPage — Mode inventaire (saisie des quantités physiques)
// StockPro / VisualisPro
// -----------------------------------------------------------------------------

import { T } from "../../i18n/translations";
import { getColors } from "../../styles/theme";
import { Ic, ICONS } from "../Icons";

export default function InventoryPage({
  lang,
  dark,
  accent,
  products,
  inventoryMode,
  setInventoryMode,
  inventoryCounts,
  setInventoryCounts,
  onApply,
  onExportCSV,
}) {
  const t = T[lang];
  const { textPrimary, textSecondary } = getColors(dark);

  return (
    <div className="slide-in">
      <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", marginBottom:20 }}>
        <div>
          <h1 style={{ fontSize:22, fontWeight:800, color:textPrimary }}>{t.inventoryMode}</h1>
          <p style={{ color:textSecondary, fontSize:12, marginTop:2 }}>Saisir les quantités physiques réelles</p>
        </div>
        <button
          onClick={onExportCSV}
          style={{ padding:"9px 14px", borderRadius:9, background:"rgba(99,102,241,.1)", color:"#818cf8", border:"1px solid rgba(99,102,241,.2)", fontSize:13, fontWeight:600, cursor:"pointer", display:"flex", alignItems:"center", gap:6, marginBottom:16 }}
        >
          📊 Exporter l'inventaire en CSV
        </button>
        {inventoryMode && (
          <div style={{ display:"flex", gap:8 }}>
            <button
              onClick={() => { setInventoryMode(false); setInventoryCounts({}); }}
              style={{ padding:"9px 14px", borderRadius:9, background:dark?"rgba(255,255,255,.06)":"rgba(0,0,0,.06)", color:textSecondary, fontSize:13, fontWeight:600, cursor:"pointer", border:"none" }}
            >
              {t.cancel}
            </button>
            <button
              className="glow-btn"
              onClick={onApply}
              style={{ padding:"9px 16px", borderRadius:9, background:`linear-gradient(135deg,${accent},#f7931e)`, color:"#fff", fontSize:13, fontWeight:700, cursor:"pointer", border:"none" }}
            >
              {t.applyInventory}
            </button>
          </div>
        )}
      </div>
      {!inventoryMode ? (
        <div className="card" style={{ padding:"40px", textAlign:"center" }}>
          <div style={{ width:54, height:54, background:`${accent}15`, borderRadius:"50%", display:"flex", alignItems:"center", justifyContent:"center", margin:"0 auto 16px" }}>
            <Ic d={ICONS.clip} size={26} color={accent} />
          </div>
          <div style={{ fontWeight:700, color:textPrimary, fontSize:16, marginBottom:8 }}>Démarrer un inventaire</div>
          <p style={{ color:textSecondary, fontSize:13, marginBottom:20 }}>
            Saisissez les quantités réelles. Les écarts sont calculés automatiquement et sauvegardés dans Firestore.
          </p>
          <button
            className="glow-btn"
            onClick={() => setInventoryMode(true)}
            style={{ padding:"11px 24px", borderRadius:10, background:`linear-gradient(135deg,${accent},#f7931e)`, color:"#fff", fontWeight:700, fontSize:14, cursor:"pointer", border:"none" }}
          >
            Commencer
          </button>
        </div>
      ) : (
        <div style={{ display:"flex", flexDirection:"column", gap:7 }}>
          {products.map(p => {
            const physical = inventoryCounts[p.id] ?? "";
            const diff = physical !== "" ? parseFloat(physical) - p.qty : null;
            return (
              <div key={p.id} className="card" style={{ padding:"12px 15px" }}>
                <div style={{ display:"flex", alignItems:"center", gap:10 }}>
                  <div style={{ flex:1 }}>
                    <div style={{ fontWeight:700, color:textPrimary, fontSize:13 }}>{p.name}</div>
                    <div style={{ fontSize:11, color:textSecondary }}>{p.cat} · {p.zone}</div>
                  </div>
                  <div style={{ textAlign:"center", minWidth:80 }}>
                    <div style={{ fontSize:10, color:textSecondary, marginBottom:3 }}>{t.theoreticalQty}</div>
                    <div style={{ fontSize:16, fontWeight:800, color:textPrimary, fontFamily:"'JetBrains Mono',monospace" }}>
                      {p.qty} <span style={{ fontSize:11, fontWeight:400 }}>{p.unit}</span>
                    </div>
                  </div>
                  <div style={{ textAlign:"center", minWidth:90 }}>
                    <div style={{ fontSize:10, color:textSecondary, marginBottom:3 }}>{t.physicalQty}</div>
                    <input
                      className="fi"
                      type="number"
                      min="0"
                      value={physical}
                      onChange={(e) => setInventoryCounts(prev => ({ ...prev, [p.id]: e.target.value }))}
                      style={{ width:80, textAlign:"center", fontFamily:"'JetBrains Mono',monospace", fontWeight:700, fontSize:14 }}
                    />
                  </div>
                  {diff !== null && (
                    <div style={{ textAlign:"center", minWidth:60 }}>
                      <div style={{ fontSize:10, color:textSecondary, marginBottom:3 }}>{t.difference}</div>
                      <div style={{ fontSize:14, fontWeight:800, fontFamily:"'JetBrains Mono',monospace", color:diff===0?"#10b981":diff>0?"#60a5fa":"#f87171" }}>
                        {diff > 0 ? "+" : ""}{diff}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
